// extracted by mini-css-extract-plugin
export default {"displayField":"DisplayField_displayField__GoMm4","label":"DisplayField_label__GWLGR"};